import { render, staticRenderFns } from "./InfoChild.vue?vue&type=template&id=7b949d30&scoped=true"
import script from "./InfoChild.vue?vue&type=script&lang=js"
export * from "./InfoChild.vue?vue&type=script&lang=js"
import style0 from "./InfoChild.vue?vue&type=style&index=0&id=7b949d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b949d30",
  null
  
)

/* custom blocks */
import block0 from "./InfoChild.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports